import { RotateCcw } from "lucide-react";
import { CardPaymentButton, PaypalPaymentButton } from "./PaymentProviderButtons";

export const TipAmounts = ({ tips, lookupKey, onChange }) => (
  <div className="mt-6">
    <span className="font-mono-ui text-[11px] uppercase text-slate-400">Montant</span>
    <div className="mt-2 grid grid-cols-4 gap-2" data-testid="tip-amounts">
      {tips.map((tip) => <button key={tip.lookup_key} type="button" onClick={() => onChange(tip.lookup_key)} aria-pressed={lookupKey === tip.lookup_key} data-testid={`tip-amount-${tip.amount}`} className={`py-3 rounded-lg border font-display text-xl transition-colors ${lookupKey === tip.lookup_key ? "border-amber-400 text-amber-300 bg-amber-400/10" : "border-line text-slate-400 hover:text-slate-200"}`}>{tip.amount} €</button>)}
    </div>
  </div>
);

export const TipConfigState = ({ error, retry }) => {
  if (!error) return <p className="mt-6 text-slate-400" role="status" data-testid="tip-config-loading">Chargement des paiements…</p>;
  return <div role="alert" className="mt-6 text-red-300" data-testid="tip-config-error">Les paiements sont indisponibles pour le moment.
    <button onClick={retry} data-testid="tip-config-retry-button" className="mt-3 inline-flex items-center gap-2 underline"><RotateCcw size={14} />Réessayer</button>
  </div>;
};

export const TipPaymentButtons = ({ config, selected, loading, payCard }) => {
  return <div className="mt-6 grid gap-3">
    {config.stripe_mode === "test" && <p className="rounded-lg border border-amber-400/30 p-3 text-xs text-amber-200" data-testid="tip-stripe-test-notice">Carte bancaire en mode test : aucun argent réel n'est encaissé. Pour un soutien réel, choisis PayPal.</p>}
    <CardPaymentButton enabled={config.stripe_enabled} selected={selected} loading={loading} payCard={payCard} />
    <PaypalPaymentButton url={config.paypal_url} selected={selected} />
  </div>;
};